<template>
  <button type="button" class="close" :title="$t(props.title)" v-bind="$attrs">
    {{ $t(props.title) }}
  </button>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string;
  }>(),
  {
    title: "common.close",
  }
);
</script>
